/**
 * Sums the values of the given items, optionally by the values of the given keys.
 */
export function sum(items: number[]): number;
export function sum<T extends Record<string, any>>(
  items: T[],
  key: keyof T
): number;
export function sum<T extends number[]>(
  items: T[] | number[],
  key?: keyof T
): number {
  let sum = 0;
  for (const item of items) {
    if (typeof item === 'number') {
      sum += item;
    } else if (key) {
      sum += Number.parseInt(String(item[key]), 10);
    }
  }
  return sum;
}
